import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import CategoryFilter from '../../common/components/categoryFilter';
import { hasCategories } from '../../common/helpers/categoryHelpers';
import FeedCard from '../../common/components/feedCard';
import DataAid from '../../common/constants/data-aids';
import Field from '../../common/constants/editable-field-tags';
import wrapWithDeviceDetection from '../../common/wrapWithDeviceDetection';

class CardGroup extends Component {
  static get propTypes() {
    return {
      feeds: PropTypes.array.isRequired,
      detachedMode: PropTypes.bool.isRequired,
      staticContent: PropTypes.object.isRequired,
      device: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      cardClickHandler: PropTypes.func,
      categoryClickHandler: PropTypes.func,
      categories: PropTypes.array,
      selectedCategory: PropTypes.string,
      imgParams: PropTypes.string,
      viewDevice: PropTypes.string.isRequired,
      currentPageRoute: PropTypes.string,
      locale: PropTypes.string
    };
  }

  onHandleStyles(isLastPost) {
    const imageSize = '200px';
    return {
      container: {
        'display': 'flex',
        'flexDirection': 'column',
        'paddingBottom': 'xlarge',
        'marginBottom': isLastPost ? '0' : 'xlarge',
        'borderBottomWidth': isLastPost ? '0' : '1px',
        'borderBottomStyle': 'solid',
        'borderColor': 'section',
        '@sm': {
          flexDirection: 'row',
          alignItems: 'start'
        }
      },
      content: {
        '@sm': {
          display: 'flex',
          minWidth: '1px', // IE bug
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingBottom: 'xxsmall'
        }
      },
      text: {
        marginBottom: 'small'
      },
      backgroundContainer: {
        'display': 'flex',
        'height': imageSize,
        'flexShrink': '0', // IE bug
        'marginBottom': 'large',
        '@sm': {
          width: imageSize,
          marginBottom: '0',
          marginRight: 'large'
        }
      },
      background: {
        'width': '100%',
        'backgroundSize': 'auto',
        'backgroundRepeat': 'no-repeat',
        '@sm': {
          backgroundPosition: 'top'
        }
      }
    };
  }

  renderCategories() {
    const { categories, categoryClickHandler, selectedCategory, staticContent } = this.props;

    return (
      <UX2.Component.Grid.Cell
        xs='12'
        md='3'
        style={{
          'marginBottom': 'small',
          '@md': {
            order: '1',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid',
            borderColor: 'section'
          }
        }}
      >
        <UX2.Element.Heading
          group='NavVertical'
          style={{
            'display': 'none',
            '@md': {
              display: 'block'
            }
          }}
        >
          {staticContent.categories}
        </UX2.Element.Heading>
        <CategoryFilter
          categoryClickHandler={ categoryClickHandler }
          categories={ categories }
          selectedCategory={ selectedCategory }
          staticContent={ staticContent }
          renderVertically={ true }
        />
      </UX2.Component.Grid.Cell>
    );
  }

  renderCards(colProps) {
    const {
      feeds,
      locale,
      detachedMode,
      staticContent,
      cardClickHandler,
      imgParams,
      viewDevice,
      currentPageRoute,
      device
    } = this.props;
    const feedsToDisplay = detachedMode ? feeds.slice(0, 2) : feeds;

    return feedsToDisplay.map((feed, index) => {
      const isLastPost = index === feedsToDisplay.length - 1;
      const style = this.onHandleStyles(isLastPost);
      return (
        <UX2.Component.Grid.Cell key={ index } { ...colProps }>
          <FeedCard
            feed={ feed }
            style={ style }
            locale={ locale }
            showContent
            staticContent={ staticContent }
            dataAid={ `${DataAid.RSS_FEED_RENDERED}_${index}` }
            cardClickHandler={ cardClickHandler }
            imgParams={ imgParams }
            viewDevice={ viewDevice }
            currentPageRoute={ currentPageRoute }
            showCategories
            device={ device }
            isRss3
          />
        </UX2.Component.Grid.Cell>
      );
    });
  }

  render() {
    const showCategories = hasCategories(this.props.categories);

    return (
      <UX2.Component.Grid
        bottom={ false }
        data-aid={ DataAid.RSS_FEEDS_RENDERED }
        data-route={ Field.FEED_URL }
      >
        {showCategories && this.renderCategories()}
        {showCategories ? (
          <UX2.Component.Grid.Cell xs='12' md='9'>
            {this.renderCards({ xs: '12' })}
          </UX2.Component.Grid.Cell>
        ) : (
          this.renderCards({ xs: '12', md: '8', pushMd: '2' })
        )}
      </UX2.Component.Grid>
    );
  }
}

export default wrapWithDeviceDetection(CardGroup);
